import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { EnhancedPanelBone } from '../../organisms/EnhancedPanelBone/EnhancedPanelBone';

interface EnhancedPanelSkeletonProps {
    /** Mode d'affichage */
    skeletonMode?: 'simple' | 'enhanced';
    /** Durée minimale */
    minDuration?: number;
    /** Largeur */
    width?: string;
    /** Hauteur */
    height?: string;
    /** Styles personnalisés */
    sx?: SxProps<Theme>;
}

export const EnhancedPanelSkeleton: React.FunctionComponent<EnhancedPanelSkeletonProps> =
    function ({
        skeletonMode = 'enhanced',
        minDuration = 800,
        width = '90%',
        height = '100%',
        sx = {},
    }) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%',
                    height: '100vh',
                    ...sx,
                }}
            >
                <EnhancedPanelBone
                    mode={skeletonMode}
                    minDuration={minDuration}
                    width={width}
                    height={height}
                />
            </Box>
        );
    };
